import { MONTHS } from 'config'
import dayjs from 'dayjs'

export const getDaysInMonth = (month: number, year: number): string[] =>
  new Array(31)
    .fill('')
    .map((_v, i) => new Date(year, month - 1, i + 1))
    .filter((v) => v.getMonth() === month - 1)
    .map((v, _i) => `${v.getDate()}`)

export const getHours = (): string[] =>
  new Array(24)
    .fill('')
    .map((_v, i) => `${i < 10 ? '0' + i.toString() : i.toString()}`)

export const getMetricUnit = (serviceType: string): string => {
  switch (serviceType) {
    case 'electric':
      return 'kWh'
    case 'water':
      return 'CF'
    case 'gas':
      return 'CF'
    default:
      return ''
  }
}

export const getMetricUnitLabel = (serviceType: string): string => {
  switch (serviceType) {
    case 'electric':
      return 'Kilowatt-hour'
    case 'water':
      return 'Cubic foot'
    case 'gas':
      return 'Cubic foot'
    default:
      return ''
  }
}

export const valueFormatter = (
  value: number | string | null,
  serviceType: string
): string => {
  return `${value ?? '0'} ${getMetricUnit(serviceType)}`
}

export const getXAxisData = (
  filters: Record<string, Record<string, string>>,
  serviceType: string,
  viewType: string
): any => {
  if (viewType === 'monthly') {
    return MONTHS
  } else if (viewType === 'daily') {
    const dateFilter = filters[serviceType][viewType]
    const year = Number(dateFilter.split('-')[0])
    const month = Number(dateFilter.split('-')[1])
    return getDaysInMonth(month, year)
  } else if (viewType === 'hourly') {
    return getHours()
  }
}

export const getSeriesDataLength = (viewType: string, xAxisData: any): any => {
  if (viewType === 'monthly') {
    return 12
  } else if (viewType === 'daily') {
    return xAxisData.length
  } else if (viewType === 'hourly') {
    return 24
  }
}

export const getUsagePayload = (
  filters: Record<string, Record<string, string>>,
  serviceType: string,
  viewType: string
): any => {
  let startDate, endDate
  const service = serviceType.toUpperCase()
  const frequency = viewType.toUpperCase()[0]
  const dateFilter = filters[serviceType][viewType]

  if (viewType === 'monthly') {
    startDate = `${dateFilter}-01-01`
    endDate = dayjs(`${dateFilter}-12-31`).format('YYYY-MM-DD')
  } else if (viewType === 'daily') {
    startDate = dayjs(`${dateFilter}-01`).format('YYYY-MM-DD')
    endDate = dayjs(`${dateFilter}-01`).endOf('month').format('YYYY-MM-DD')
  } else if (viewType === 'hourly') {
    startDate = `${dateFilter}:00:00:00`
    endDate = `${dateFilter}:23:59:59`
  }

  return {
    service,
    frequency,
    startDate,
    endDate
  }
}
